import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  DraggedAppliance,
  DraggedApplianceState,
} from './draggedAppliance.type';

const initialState: DraggedApplianceState = null;

const draggedApplianceSlice = createSlice({
  name: 'draggedAppliance',
  initialState: initialState as DraggedApplianceState,
  reducers: {
    setDraggedAppliance: (_, action: PayloadAction<DraggedAppliance>) =>
      action.payload as DraggedApplianceState,
    resetDraggedAppliance: (_) => initialState,
  },
});

export const { setDraggedAppliance, resetDraggedAppliance } =
  draggedApplianceSlice.actions;

export default draggedApplianceSlice.reducer;
